import { render, staticRenderFns } from "./GoDC.vue?vue&type=template&id=30253582"
import script from "./GoDC.vue?vue&type=script&lang=js"
export * from "./GoDC.vue?vue&type=script&lang=js"
import style0 from "./GoDC.vue?vue&type=style&index=0&id=30253582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports